/**
 * Compute the selling price from the cost price and margin
 *
 * @param {number} costPrice - The cost price
 * @param {number} margin - The margin
 *
 * @returns {number} The selling price
 */
export default function computeSellingPriceFromMargin(costPrice, margin) {
  return (costPrice / (1 - margin / 100)).toFixed(2);
}
